import React, { useState, useEffect } from "react";
import axios from "axios";

import "./App.css";
import Searchapi from "./components/searchapi";
import Entries from "./components/entries";

function App() {
  const [categories, setCategories] = useState([]);
  const [entries, setEntries] = useState([]);
  const [category, setCategory] = useState("");

  const baseUrl = "https://api.publicapis.org/";

  async function getEntires(e) {
    setEntries([]);
    setCategory('')

    if(e.length>0){
      e = encodeURIComponent(e);

    
    try {
      const res = await axios(baseUrl + "entries?category=" + e);

      setEntries(res.data.entries);
    } catch (error) {
      console.log(error);
    }

    setCategory(decodeURIComponent(e));
    }
    
  }

  const getCategories = () => {
    fetch(baseUrl + "categories").then((res) => {
      return res
        .json()
        .then((cat) => {
          setCategories(cat);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  // const selectCategory=(category)=>{
  //     setCategory(category)
  // }
  useEffect(getCategories, []);

  return (<div>
<h1 className="text-center bg-dark text-white vw-100">Public API List</h1>
    <div className="App container">
      

      <Searchapi cat={categories} entry={getEntires} />
      <Entries category={category} entries={entries} />
    </div>
  </div>
    
  );
}

export default App;
